export default __webpack_public_path__ + "media/Confluence_mobile.daa0dcebc0e62c0c3d3c547167915c9b.svg";